import { Dialog, FormDatePicker, FormInput, FormSelect, Loader } from "@/components"
import { FormProvider } from "react-hook-form"
import { AddDistributionJobProps } from "./types"
import useAddDistributionJob from "./useAddDistributionJob"
import { FREQUENCY, frequencyTabs, RUN_TYPE } from "../consts"
import { JOB_ID, PERIOD_FROM, PERIOD_TO, SCHEDULED_ON, STATUS } from "./consts"
import { Button } from "@/components/ui"

const AddDistributionJob = ({open, setOpen, jobId, isEdit, frequency, type}: AddDistributionJobProps) => {
  const {form, onSubmit, isAddPending, isLoadingJobData, isUpdatePending
  } = useAddDistributionJob({jobId, isEdit, frequency, type, setOpen});
  const {errors} = form.formState;

  return (
    <Dialog open={open} setOpen={setOpen} 
      title={isEdit ? `Edit Job ID: ${jobId}`: "Add Job"} 
      contentClassName="!w-[500px]" hideFooter
    >
      {isLoadingJobData ? <Loader /> :
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
              {isEdit && <FormInput 
                name={JOB_ID}
                control={form.control}
                placeholder="Please Enter"
                label="Job Id"
                error={(errors as any)[JOB_ID]?.message}
                isRequired={false}
                disabled
              />}
              <FormInput 
                name={RUN_TYPE}
                control={form.control}
                placeholder="Please Enter"
                label="Run Type"
                error={(errors as any)[RUN_TYPE]?.message}
                isRequired={false}
                disabled
              />
              <FormSelect
                name={FREQUENCY}
                control={form.control}
                placeholder="Please Select"
                label="Frequency"
                error={(errors as any)[RUN_TYPE]?.message}
                isRequired={false}
                options={frequencyTabs || []}
                disabled
              />
              <FormDatePicker
                name={PERIOD_FROM}
                control={form.control}
                label="Period From"
                placeholder="Please select"
                error={errors[PERIOD_FROM]?.message}
                isRequired={true}
              />
              <FormDatePicker
                name={PERIOD_TO}
                control={form.control}
                label="Period To"
                placeholder="Please select"
                error={errors[PERIOD_TO]?.message}
                isRequired={true}
                minDate={form.watch(PERIOD_FROM)}
              />
              <FormDatePicker
                name={SCHEDULED_ON}
                control={form.control}
                label="Scheduled On"
                placeholder="Please select"
                error={errors[SCHEDULED_ON]?.message}
                isRequired={true}
              />
              {isEdit && <FormInput
                name={STATUS}
                control={form.control}
                placeholder="Please Select"
                label="Status"
                error={(errors as any)[STATUS]?.message}
                isRequired={false}
                disabled
              />}
            </div>

            <div className="mt-4 items-end justify-end flex flex-row gap-3">
              <Button disabled={isAddPending || isUpdatePending} variant="outline" type="button" onClick={() => setOpen(false)}>Cancel</Button>
              <Button disabled={isAddPending || isUpdatePending}>{(isAddPending || isUpdatePending) ? <Loader variant="secondary"/> : <></>} Save</Button>
            </div>
          </form>
        </FormProvider>
      }
    </Dialog>
  )
}

export default AddDistributionJob;